import { useParams } from "@tanstack/react-router";

import AudioTranscriberPage from "./AudioTranscriberPage";

/**
 * Route entry for the Assessment Scribe.
 *
 * Remounts the whole page per case via `key={caseNumber}` (MDRS-155): switching
 * cases is a route-param change on the same `/report-studio/$id/assessment-scribe`
 * route, so TanStack reuses the page instance. Without the key, the page's
 * per-case local state (edits, summaries, live segments, session notes, the
 * autosave interval in useAutoExport) survives the switch — showing the previous
 * case's content and, worse, letting an autosave persist it onto the newly
 * selected case. Keying by caseNumber forces a fresh mount so all that state and
 * its timers reset cleanly.
 */
const AudioTranscriberRoute = () => {
  const { id: caseNumber } = useParams({ strict: false }) as { id: string };
  return <AudioTranscriberPage key={caseNumber} />;
};

export default AudioTranscriberRoute;
